import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ToastNotification {
  id: number;
  title: string;
  message: string;
  priority: "info" | "warning" | "urgent";
  read?: boolean;
}

interface ToastState {
  toastStack: ToastNotification[];
}

const initialState: ToastState = {
  toastStack: [],
};

let nextToastId = 1;

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    addToast: (
      state,
      action: PayloadAction<Omit<ToastNotification, "id" | "read">>
    ) => {
      const isDuplicate = state.toastStack.some(
        (toast) =>
          toast.title === action.payload.title &&
          toast.message === action.payload.message
      );
      
      if (!isDuplicate) {
        state.toastStack.push({
          ...action.payload,
          id: nextToastId++,
          read: false,
        });
      }
    },
    dismissToast: (state, action: PayloadAction<number>) => {
      state.toastStack = state.toastStack.filter(
        (toast) => toast.id !== action.payload
      );
    },
    markAsRead: (state, action: PayloadAction<number>) => {
      const toast = state.toastStack.find((t) => t.id === action.payload);
      if (toast) {
        toast.read = true;
      }
    },
  },
});

export const { addToast, dismissToast, markAsRead } = toastSlice.actions;

export default toastSlice.reducer;

